"use client";

import { createContext, useContext } from "react";
import { UserData } from "@/types/api/login";

interface AuthContextType {
  user: UserData | null;
  isLoading: boolean;
  isProfileLoading: boolean;
  isAuthenticated: boolean;
  setAuth: (
    accessToken: string,
    refreshToken: string,
    userData: UserData
  ) => Promise<void>;
  logout: () => Promise<void>;
  fetchUserProfile: () => Promise<void>;
  getCurrentAuthState: () => boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}

export { AuthContext };
export type { AuthContextType };
